import PropTypes from "prop-types"
import { TextField } from "@mui/material"
import { useRef, useState } from "react"
import { isEnterKey, isEscapeKey } from "helpers/keyboard"

// Inline rename with auto-save: commits when focus leaves or Enter is pressed, cancels on Escape. An
// empty or unchanged title cancels without a write. The commit runs at most once so the blur that
// follows an Enter (or the field unmounting) does not save twice.
export default function ThreadRenameField({ initialTitle, onSave, onCancel, isSaving }) {
  const [value, setValue] = useState(initialTitle)
  const hasCommitted = useRef(false)

  async function commit() {
    if (hasCommitted.current) {
      return
    }
    hasCommitted.current = true
    const trimmed = value.trim()
    if (!trimmed || trimmed === initialTitle.trim()) {
      onCancel()
      return
    }
    try {
      await onSave(trimmed)
    } catch {
      // The save failed (the parent surfaces the error); reopen the field so the edit can be retried.
      hasCommitted.current = false
    }
  }

  function handleKeyDown(e) {
    if (isEnterKey(e)) {
      commit()
    } else if (isEscapeKey(e)) {
      hasCommitted.current = true
      onCancel()
    }
  }

  return <TextField
    autoFocus
    fullWidth
    size="small"
    variant="standard"
    aria-label="Rename thread"
    className="thread-list-item-rename-text-field"
    value={value}
    disabled={isSaving}
    onChange={(e) => setValue(e.target.value)}
    onKeyDown={handleKeyDown}
    onBlur={commit}
  />
}

ThreadRenameField.propTypes = {
  initialTitle: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
}
